import React, {createRef, useContext, useEffect, useRef, useState} from "react";
import {UserContext} from "../../contexts/UserContext";
import {CompanyType} from "../../models/company";
import {BidConfigMetaData, Cell, cellsDecoder, cellsEncoder} from "./bidConfig_model";
import {Button} from "../ui/button";
// import {moneyFormatter} from "../../lib/formatters";
import {USDonChange, USDtoValue} from "../fields/USDField";
import {Badge} from "../ui/badge"
import {rankBadge} from "../fields/feedback";

type BidFormConfigProps = {
    data: Cell[][];
    setData: (data: Cell[][]) => void;
    readonly: boolean;
    enable_row_col: boolean;
    setHist?: (hs_item: any) => void;
    hist?: any[]
};


/**
 *
 * */
export function make_blank_sheet() {
    const n = 5
    const m = 3
    const arr = new Array(m).fill(null).map(() => new Array(n).fill({value: "", party: false}));
    for (var i = 0; i < m; i++) {
        for (var j = 0; j < n; j++) {
            arr[i][j] = {value: "", party: false};
        }
    }
    return arr
}


type DataCellProps = {
    i: number,
    j: number,
    myIndex: [number, number] | null,
    cell: Cell,
    itemsRef: any,
    isBuilderBit: boolean,
    Ncol: number,
    readonly : boolean,
    handleFocus: (e:any, i:number, j:number)=> void;
    handleKeyPress: (e:any, i:number, j:number)=> void;
    setCellType: (e:any, i:number, j:number)=> void;
    setCellParty: (e:any, i:number, j:number)=> void;
    update: (e:any, i:number, j:number)=> void;
}


function cellFormatter(cell: Cell){
    if (cell.party){
        if(cell.type === 'txt'){
            return cell.value;
        } else if (cell.type === 'num'){
            return cell.value;
        } else {
            return USDtoValue(cell.value);
        }
    }
    return cell.value;
}

function inverseFormatter(cell: Cell, new_value:any){
    if (cell.party){
        if(cell.type === 'txt'){
            return new_value;
        } else if (cell.value === 'num'){
            return new_value;
        } else {
            return USDonChange(new_value);
        }
    }
    return new_value;
}

function DataCell({i, j, myIndex, cell, isBuilderBit,
                      itemsRef, Ncol, readonly, update, handleFocus, handleKeyPress,
                  setCellParty, setCellType}: DataCellProps) {
    const isDeveloperBit = !isBuilderBit;

    return <td key={j} className=" relative">
        <input
            ref={(el) => (itemsRef.current[i * Ncol + j] = el ? {current: el} : null)}
            onFocus={(e) => handleFocus(e, i, j)}
            onKeyDown={(e) => handleKeyPress(e, i, j)}
            onChange={(e) => update(e, i, j)}
            value={cellFormatter(cell)} //.value}
            disabled={readonly}
            className={
                "w-full p-1 border rounded-sm focus:outline-none" +
                " focus:ring-2 focus:ring-blue-500" +
                (!(isBuilderBit === cell.party)
                    ? " bg-slate-200"
                    : "")
            }
            placeholder={
                !(isBuilderBit === cell.party) && isDeveloperBit
                    ? ((cell.type ? "(" + cell.type + "):" : "") + "bidder input")
                    : ""}
        />
        {isDeveloperBit &&
        myIndex &&
        myIndex[0] === i &&
        myIndex[1] === j ?
            (<>
            {!(isBuilderBit === cell.party)  ? //
                <div className="absolute right-7 top-1">
                    <select
                        value={cell.type ? cell.type : "$"}
                        onChange={(e) => setCellType(e, i, j)}
                    >
                        <option value="$">$</option>
                        <option value="num">Number</option>
                        <option value="txt">Text</option>
                    </select>
                </div>: <></>
            }
            <div className="absolute right-2 top-1">
                <input
                    type="checkbox"
                    checked={cell.party}
                    onChange={(e) => setCellParty(e, i, j)}
                />
            </div>
            </>
        ) : (
            <></>
        )}
        {cell.feedback
            ? <div className="absolute right-7 top-1">
                {rankBadge(cell.feedback.rank)}
            </div>
            : <></>}
    </td>
}


function DataSheet({data, setData, enable_row_col, readonly, hist, setHist}: BidFormConfigProps) {
    const userContext = useContext(UserContext);
    // 0(false)=Developer, 1(true)=bidder
    const isBuilderBit = userContext?.company_type === CompanyType.builder;
    const isDeveloperBit = userContext?.company_type === CompanyType.developer;

    const itemsRef = useRef<(React.RefObject<HTMLInputElement> | null)[]>([]);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [myIndex, setMyIndex] = useState<[number, number] | null>(null);

    const Nrow = data.length;
    const Ncol = data.length > 0 && data[0] ? data[0].length : 0;

    useEffect(() => {
        if (data.length > 0 && data[0]) {
            const arrLength = data[0].length * data.length;
            itemsRef.current = Array(arrLength)
                .fill(null)
                .map((_, i) => itemsRef.current[i] || createRef<HTMLInputElement>());
        }
    }, [data]);

    // Handle click outside the container (table + buttons) to reset myIndex
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current &&
                !containerRef.current.contains(event.target as Node)) {
                setMyIndex(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [containerRef]);

    const update = (event: any, i: number, j: number) => {
        //
        // if builder and cell is input
        // or if developer and is not input
        if (isBuilderBit === data[i][j].party) {

            let new_value = inverseFormatter(data[i][j], event.target.value)

            const newData = [...data];
            if (setHist && hist) {
                if (hist.length > 0) {
                    // @ts-ignore
                    let last = hist[hist.length - 1]
                    if (last && last.w && last.w[0] === i && last.w[1] === j) {
                        hist[hist.length - 1].v = new_value;
                        setHist([...hist])
                    } else {
                        setHist([...hist, {
                            'w': [i, j],
                            'o': newData[i][j].value,
                            'v': new_value
                        }])
                    }
                } else {
                    setHist([...hist, {
                        'w': [i, j],
                        'o': newData[i][j].value,
                        'v': new_value
                    }])
                }
            }
            newData[i][j].value = new_value;
            setData(newData);
        }
    };

    const addCol = () => {
        if (Ncol === 0 || Nrow === 0 || !enable_row_col) return;

        let colIndex = myIndex ? myIndex[1] + 1 : Ncol;
        if (setHist && hist) {
            setHist([...hist, {'ac': colIndex}])
        }
        const newData = data.map((row) => {
            const newRow = [...row];
            newRow.splice(colIndex, 0, {value: "", party: isBuilderBit});
            return newRow;
        });
        setData(newData);
    };

    const addRow = () => {
        if (Ncol === 0 || !enable_row_col) return; // Avoid adding rows when there's no data

        let rowIndex = myIndex ? myIndex[0] + 1 : Nrow;
        if (setHist && hist) {
            setHist([...hist, {'ar': rowIndex}])
        }
        let newRow = Array(Ncol)
            .fill(null)
            .map(() => ({value: "", party: isBuilderBit}));
        const newData = [...data];
        newData.splice(rowIndex, 0, newRow);
        setData(newData);
    };

    const removeCol = () => {
        if (Ncol === 0 || !myIndex || !enable_row_col) return; // Avoid removing column when there's no data or no active cell

        const colIndex = myIndex[1];
        if (setHist && hist) {
            setHist([...hist, {'dc': colIndex}])
        }
        const newData = data.map((row) => {
            const newRow = [...row];
            newRow.splice(colIndex, 1); // Remove the column
            return newRow;
        });
        setData(newData);
    };

    const removeRow = () => {
        if (Nrow === 0 || !myIndex || !enable_row_col) return; // Avoid removing row when there's no data or no active cell

        const rowIndex = myIndex[0];

        if (setHist && hist) {
            setHist([...hist, {'dr': rowIndex}])
        }

        const newData = [...data];
        newData.splice(rowIndex, 1); // Remove the row
        setData(newData);
    };

    const _updateHist = (key: string, value:any, i:number, j:number) => {
        if (setHist && hist) {
            setHist([...hist,  {'w': [i, j], [key]: value}])
        }
    }

    const setCellParty = (e: any, i: number, j: number) => {
        // only developer can do this ...
        if (isDeveloperBit) {
            const newData = [...data];

            newData[i][j].party = e.target.checked;
            _updateHist('party', e.target.checked, i, j)


            setData(newData);
        }
    };

    const setCellType = (e: React.ChangeEvent<HTMLSelectElement>, i: number, j: number) => {
        // only developer can do this ...
        if (isDeveloperBit) {
            const newData = [...data];
            _updateHist('type', e.target.value, i, j)
            newData[i][j].type = e.target.value;
            setData(newData);
        }
    };

    const back = (e: any) => {
        // let last = hist.pop()
    }

    const handleKeyPress = (event: any, i: number, j: number) => {
        let next;
        if (event.keyCode === 38 && i > 0) {
            // up arrow
            next = itemsRef.current[(i - 1) * Ncol + j];
        } else if (event.keyCode === 37 && j > 0) {
            // left arrow key
            next = itemsRef.current[i * Ncol + j - 1];
        } else if (event.keyCode === 39 && j < Ncol - 1) {
            // right key
            next = itemsRef.current[i * Ncol + j + 1];
        } else if (event.keyCode === 40 && i < Nrow - 1) {
            // down key
            next = itemsRef.current[(i + 1) * Ncol + j];
        } else if (event.keyCode === 13 && i < Nrow - 1) {
            // enter key
            next = itemsRef.current[(i + 1) * Ncol + j];
        } else if (event.ctrlKey && event.key === 'd') {
            event.preventDefault()
            if (isDeveloperBit) {
                const newData = [...data];
                newData[i][j].party = !newData[i][j].party;
                setData(newData);
            }
            return;
        }
        if (next && next.current) next.current.focus();
    };

    const handleFocus = (event: any, i: number, j: number) => {
        setMyIndex([i, j]);
    };

    return (
        <div ref={containerRef}>
            {(enable_row_col) && (
                <div className="flex columns-2 justify-between">
                    {/*<div>*/}
                    {/*    {hist && hist.length > 0 // todo- keep this around  */  }
                    {/*        ? <Button onClick={back} variant="outline"> {"<-"}</Button>*/}
                    {/*        : <></>}*/}
                    {/*</div>*/}
                    <div></div>
                    <div className="flex gap-2 mb-4">
                        <Button onClick={addRow} variant="outline">+R</Button>
                        <Button onClick={addCol} variant="outline">+C</Button>
                        <Button onClick={removeRow} variant="outline">-R</Button>
                        <Button onClick={removeCol} variant="outline">-C</Button>
                    </div>
                </div>
            )}
            <div className="relative w-full overflow-auto">
                <table className="w-full text-sm text-left table-auto border-separate border-spacing-2">
                    <thead></thead>
                    <tbody className="[&_tr:last-child]:border-0">
                    {data.map((row, i) => (
                        <tr key={i}
                            className="border-b border-gray-200 transition-colors ">
                            {row.map((cell, j) => (
                                <DataCell
                                    key={j}
                                    i={i}
                                    j={j}
                                    myIndex={myIndex}
                                    isBuilderBit={isBuilderBit}
                                    setCellParty={setCellParty}
                                    setCellType={setCellType}
                                    update={update}
                                    itemsRef={itemsRef}
                                    cell={cell}
                                    readonly={readonly}
                                    handleKeyPress={handleKeyPress}
                                    handleFocus={handleFocus}
                                    Ncol={Ncol}
                                />
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>

    );
}

export default DataSheet